import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSavedOpportunities } from '../contexts/SavedOpportunitiesContext';
import { DEFAULT_REGION, buildRegionPath, useActiveRegion } from '../regions';

const SavedOpportunityToast: React.FC = () => {
  const { toast, dismissToast, undoToastAction } = useSavedOpportunities();
  const navigate = useNavigate();
  const region = useActiveRegion() ?? DEFAULT_REGION;

  useEffect(() => {
    if (!toast) return;
    const timer = window.setTimeout(dismissToast, 5000);
    return () => window.clearTimeout(timer);
  }, [dismissToast, toast]);

  if (!toast) return null;

  return (
    <div className="fixed bottom-5 left-1/2 z-[100] flex w-[calc(100%_-_2rem)] max-w-md -translate-x-1/2 items-center justify-between gap-4 rounded-xl bg-slate-900 px-4 py-3 text-sm text-white shadow-2xl" role="status">
      <span>{toast.message}</span>
      {toast.message.startsWith('Unable') ? (
        <button type="button" onClick={dismissToast} className="font-semibold text-slate-200 hover:text-white">Dismiss</button>
      ) : toast.action === 'undo' ? (
        <button type="button" onClick={() => void undoToastAction()} className="font-semibold text-blue-300 hover:text-blue-200">Undo</button>
      ) : (
        <button type="button" onClick={() => { dismissToast(); navigate(buildRegionPath(region, 'saved')); }} className="font-semibold text-blue-300 hover:text-blue-200">View saved</button>
      )}
    </div>
  );
};

export default SavedOpportunityToast;
